export default {"src":"/_next/static/media/educator.ff2eec9f.svg","height":557,"width":851};